/* OneWear: USP carousel. Pauses while scrolling or off screen, ignores iOS toolbar resizes. */
(function () {
  if (window.owUsp) return;
  /* static dots: no animated width, no extra layer (avoids blurry dots on iOS) */
  var st = document.createElement('style');
  st.textContent = '.ow-usp .ow-usp__pagination{transform:none!important;will-change:auto!important}.ow-usp .ow-usp__bullet{transition:none!important;will-change:auto!important;-webkit-transform:none!important;transform:none!important;box-sizing:content-box!important;min-width:0!important;min-height:0!important;line-height:0!important;font-size:0!important}';
  document.head.appendChild(st);
  var lastScroll = 0;
  window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
  window.owUsp = function (root) {
    if (!root || root._owInit) return; root._owInit = 1;
    var sw = root.querySelector('.ow-usp__swiper'), wr = root.querySelector('.ow-usp__wrapper');
    if (!sw || !wr) return;
    var n = wr.children.length, bullets = root.querySelectorAll('.ow-usp__bullet');
    if (n < 2) return;
    wr.insertBefore(wr.children[n - 1].cloneNode(true), wr.children[0]);
    wr.appendChild(wr.children[1].cloneNode(true));
    var cur = 1, w = 1, timer = null, settle = null, drag = null, visible = true, active = -1;
    var EASE = 'transform 300ms cubic-bezier(.25,.8,.25,1)';
    function render(anim) { wr.style.transition = anim ? EASE : 'none'; wr.style.transform = 'translate3d(' + Math.round(-cur * w) + 'px,0,0)'; }
    function mark() {
      var r = ((Math.round(cur) - 1) % n + n) % n; if (r === active) return; active = r;
      bullets.forEach(function (b, k) { b.classList.toggle('is-active', k === r); });
    }
    function norm() { if (cur < 0.5) cur += n; else if (cur > n + 0.5) cur -= n; }
    function go(t) {
      clearTimeout(settle); w = sw.clientWidth || w; cur = t; mark(); render(true);
      settle = setTimeout(function () { var c = cur; norm(); if (c !== cur) render(false); }, 310);
    }
    function stopAnim() { clearTimeout(settle); w = sw.clientWidth || w; cur = Math.round(cur); norm(); render(false); }
    function start() {
      clearInterval(timer);
      timer = setInterval(function () {
        if (drag || !visible || document.hidden || Date.now() - lastScroll < 700) return;
        go(Math.round(cur) + 1);
      }, 5000);
    }
    function down(x, y) { clearInterval(timer); stopAnim(); drag = { x: x, y: y, dx: 0, base: cur, lock: null }; }
    function move(x, y, e) {
      if (!drag) return;
      var dx = x - drag.x, dy = y - drag.y;
      if (drag.lock === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) drag.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.lock !== 'x') return;
      if (e && e.cancelable) e.preventDefault();
      drag.dx = Math.max(-w, Math.min(w, dx));
      cur = drag.base - drag.dx / w; render(false);
    }
    function up() {
      if (!drag) return; var d = drag; drag = null;
      var base = Math.round(d.base);
      go(d.lock === 'x' && d.dx < -30 ? base + 1 : d.lock === 'x' && d.dx > 30 ? base - 1 : base);
      start();
    }
    sw.addEventListener('touchstart', function (e) { down(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    sw.addEventListener('touchmove', function (e) { move(e.touches[0].clientX, e.touches[0].clientY, e); }, { passive: false });
    sw.addEventListener('touchend', up);
    sw.addEventListener('touchcancel', up);
    sw.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', up);
    bullets.forEach(function (b, k) { b.addEventListener('click', function () { stopAnim(); go(k + 1); start(); }); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);
    var lw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth === lw) return; lw = window.innerWidth; w = sw.clientWidth || w; render(false); });
    w = sw.clientWidth || 1; render(false); mark(); start();
  };
})();
